import {
  APIReferenceTypeAttributes,
  ApiReferenceTypeOverviewRow,
} from '@ardoq/api-types';
import { fetchEntities, fetchJson, headers } from './api';
import { ApiResponse } from './types';

const fetchReferenceTypeOverview = async (): ApiResponse<
  ApiReferenceTypeOverviewRow[]
> => {
  const request = new Request(`/api/reference-type/overview`, {
    headers,
  });
  return fetchJson<ApiReferenceTypeOverviewRow[]>(request);
};

export const referenceTypeApi = {
  fetchAll: fetchEntities<APIReferenceTypeAttributes>('reference-type'),
  fetchReferenceTypeOverview,
};
